export const getHexColor = (position: number, colors: string[]) => {
  return colors[position]
}
